module.exports = __webpack_public_path__ + "img/2025-03-11-01-01.38b7a2a1.png";